import { render, staticRenderFns } from "./MailConfirmation.vue?vue&type=template&id=848b8fb0"
import script from "./MailConfirmation.vue?vue&type=script&lang=js"
export * from "./MailConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports